import LocalizedStrings from 'localized-strings';

import { PackageType } from '__generated__/GQL';

export default new LocalizedStrings({
  en: {
    months: 'months of Shine',
    packageTitle: {
      [PackageType.CapitalDeposit]: 'Capital Deposit',
      [PackageType.ShineStart]: 'Creation of a micro-enterprise',
    },
  },
  fr: {
    months: 'mois Shine',
    packageTitle: {
      [PackageType.CapitalDeposit]: 'Dépôt de capital',
      [PackageType.ShineStart]: 'Création micro entreprise',
    },
  },
} as const);
